module.exports = __webpack_public_path__ + "img/jsnsd-badge.517e564a.png";